module.exports = __webpack_public_path__ + "column2.png?ef028105edbb48101e39f3df294d21ca";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/column2.png
// module id = 339
// module chunks = 0